const ENV = process.env.REACT_APP_ENV

const CONFIG_BY_ENV = {
  local: {
    channelAppId: '447170150815426',
    authAppId: '922704847940527',
    igAppId: '311138991485932'
  },
  development: {
    channelAppId: '447170150815426',
    authAppId: '922704847940527',
    igAppId: '311138991485932'
  },
  pre: {
    channelAppId: '904164610574935',
    authAppId: '922704847940527',
    igAppId: '506068218005590'
  },
  production: {
    channelAppId: '1449938005017685',
    authAppId: '922704847940527',
    igAppId: '1051005045468512'
  }
}

export default {
  version: '15.0',
  channel: {
    appId: CONFIG_BY_ENV[ENV].channelAppId,
    fields: 'name',
    scope: 'pages_show_list,pages_manage_metadata,pages_messaging,ads_management,pages_read_engagement,pages_read_user_content,pages_manage_engagement',
    textTag: 'facebook_btn_login_with',
    icon: 'fa-facebook-official pr-3',
  },
  auth: {
    appId: CONFIG_BY_ENV[ENV].authAppId,
    fields: 'name,email,picture',
    scope: 'public_profile,email',
    textTag: '',
    icon: 'element',
  },
  instagram: {
    appId: CONFIG_BY_ENV[ENV].igAppId,
    fields: 'name',
    scope: 'pages_show_list,pages_manage_metadata,pages_read_engagement,instagram_manage_messages,instagram_manage_comments,instagram_basic',
    textTag: 'facebook_btn_login_with',
    icon: 'fa-facebook-official pr-3',
  }
}
